var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-arrow-container"},[_c('img',{staticClass:"details-arrow",class:{open: _vm.isSelected},attrs:{"src":require("@/assets/images/dropDownButton.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }